import React from "react";
import "./WhyChooseCard.css";
import { renderTextWithNormalDash } from "../../utils/textFormatters";

const WhyChooseCard = ({ icon, title }) => {
  return (
    <div className="why-choose-card text-center">
      <div className="icon-wrapper">
        <img src={icon} alt={title} className="icon-img" />
      </div>
      <h5 className="why-choose-title">{renderTextWithNormalDash(title)}</h5>
    </div>
  );
};

export default WhyChooseCard;
